export default function BundleBookingCalculator(bookingInfo) {
  if (!bookingInfo || !bookingInfo.selectedPackage) {
    return { originalPrice: 0, discountedPrice: 0 };
  }

  // Define your bundle logic here
  var bundles = {
    "10-Pack": { price: 510 },
    "20-Pack": { price: 960 },
  };

  var selected = bundles[bookingInfo.selectedPackage];
  if (!selected) {
    return { originalPrice: 0, discountedPrice: 0 };
  }

  // Return base prices (no discount; membership discount will apply later if any)
  return {
    originalPrice: selected.price,
    discountedPrice: selected.price,
  };
}
